// extracted by mini-css-extract-plugin
module.exports = {"container":"container--1YHwe","icon":"icon--2XcXh"};